// v49.2 / v49.12 — Topbar.
// Sticky bar above the main content. Page title + active tenant pill +
// notifications bell (v49.12 — unread count + dropdown preview).

import { useLocation } from "react-router";
import { useShellUser } from "@/features/auth/AuthContext";
import { pageTitleFor } from "../nav";
import { NotificationsBell } from "./NotificationsBell";

interface TopbarProps {
  onOpenSearch?: () => void;
}

export function Topbar({ onOpenSearch }: TopbarProps = {}) {
  const { pathname } = useLocation();
  const user  = useShellUser();
  const title = pageTitleFor(pathname, user?.role);

  return (
    <header
      role="banner"
      className="sticky top-0 z-10 bg-white/95 backdrop-blur-md border-b border-lc-line px-6 py-3 flex items-center gap-4"
    >
      <h1 className="text-base font-extrabold text-lc-ink tracking-tight flex-1 min-w-0 truncate">
        {title}
      </h1>

      {/* Global search trigger — Cmd-K hint on the right. */}
      {onOpenSearch && (
        <button
          type="button"
          onClick={onOpenSearch}
          className="hidden md:inline-flex items-center gap-2 px-3 py-1.5 rounded-lc-md bg-lc-bg-2 hover:bg-lc-bg-2/70 text-lc-mute hover:text-lc-ink-2 text-[12px] font-semibold transition-colors border border-lc-line"
          aria-label="Search the platform"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
          <span>Search</span>
          <kbd className="px-1.5 py-0.5 rounded-lc-sm border border-lc-line bg-white text-[10px] font-extrabold text-lc-mute leading-none">⌘K</kbd>
        </button>
      )}

      {user?.company && (
        <span
          className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-bold bg-lc-blue-light text-lc-blue-dark border border-lc-blue-border whitespace-nowrap"
          title={`Active tenant: ${user.company}`}
        >
          <span className="w-1.5 h-1.5 rounded-full bg-lc-blue" />
          {user.company}
        </span>
      )}

      {user && <NotificationsBell />}
    </header>
  );
}
